export class Config{
    //PROD
    PATH_REST_API ='https://telmed.paramedicapps.com.ar/api/';
    AUX_PATH_REST_API = 'http://shamanapps.com.ar:9876/';
    IS_TEST = false;
}
